import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  ListContainer: {
    backgroundColor : '#fff',
    flex: 1,
  },
  ListLibelle : {
    fontSize: 18,
    color: '#0F579E',
    fontWeight: '700',
    textTransform: 'uppercase',
    marginBottom: 16,
    marginLeft: 24,
    marginRight: 16,
  },
  
});
